module.exports = __webpack_public_path__ + "r-v3/img/pointer_white.d1e267a8.svg";